{/* Auto-generated icon - do not edit */}
import React from 'react'

interface WebflowIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const WebflowIcon = React.forwardRef<SVGSVGElement, WebflowIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 124 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M58.2238 20.7236C56.1485 22.751 54.398 24.2874 52.8497 26.0064C48.2775 31.1226 44.5872 36.963 41.9296 43.2891C34.9725 59.6069 29.8694 76.5496 25.3183 93.6663C24.9173 95.1759 24.8307 96.7754 24.3673 98.2606C24.0688 99.3534 23.4212 100.319 22.5233 101.009C21.6254 101.7 20.5263 102.079 19.3935 102.086C18.2618 102.123 17.1486 101.793 16.219 101.147C15.2894 100.501 14.593 99.5714 14.2328 98.4982C13.9213 97.6568 13.6874 96.7891 13.5344 95.9057C11.4091 84.2065 9.296 72.5053 7.19487 60.8022C5.14116 49.3235 3.02391 37.8552 1.14022 26.3483C0.544923 22.7116 0.586152 18.9672 0.393188 15.2688C0.3951 14.3709 0.46675 13.4745 0.607267 12.5876C0.637156 11.8477 0.926659 11.1416 1.42513 10.5939C1.92359 10.0463 2.59905 9.69199 3.33293 9.59282C4.79 9.30862 6.22801 10.2832 6.85481 12.0868C7.24101 13.3744 7.54798 14.6845 7.77376 16.0097C10.2521 27.5096 12.7292 39.0099 15.2049 50.5107C16.6515 57.194 18.1196 63.8725 19.6095 70.5468C19.8477 71.6199 20.1634 72.6759 20.6275 74.4395C22.6713 68.2496 24.4494 62.7133 26.3278 57.2112C29.37 48.2969 32.6169 39.4679 37.3543 31.2683C41.1612 24.6262 46.1687 18.7489 52.1219 13.9356C53.8684 12.5245 55.5538 11.0372 57.3135 9.64244C60.6529 6.99542 64.1616 7.67926 65.7802 11.6284C66.8419 14.4584 67.6177 17.3878 68.0955 20.3724C71.1396 36.4691 74.0911 52.5835 77.082 68.6907C77.2658 69.6752 77.5126 70.6544 77.9031 72.4147C78.421 70.6695 78.7413 69.6522 79.0261 68.625C83.4439 52.7029 88.5903 37.0742 97.0597 22.7365C100.904 16.2276 105.167 10.0402 110.726 4.88401C112.575 3.26775 114.609 1.87535 116.784 0.735431C118.763 -0.371154 120.734 0.198499 122.335 1.73564C123.761 3.10608 124.08 5.26332 122.933 7.34781C122.012 9.14552 120.835 10.7995 119.439 12.2579C107.953 23.4425 101.131 37.3623 95.8067 52.1666C90.7116 66.3337 87.25 80.9615 83.6973 95.5618C83.3993 96.8718 83.0199 98.1615 82.5612 99.4243C82.166 100.61 81.4099 101.643 80.3992 102.377C79.3878 103.112 78.1722 103.512 76.9226 103.521C75.6105 103.565 74.3215 103.169 73.2608 102.396C72.2002 101.623 71.429 100.517 71.0707 99.2543C70.1091 96.2634 69.3622 93.2075 68.8339 90.1109C65.009 67.6477 60.5545 45.2786 58.6308 22.5279C58.6052 22.1919 58.4877 21.8696 58.2238 20.7236Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="123.392" height="103.701" fill={color} transform="translate(0.32251 0.123047)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

WebflowIcon.displayName = 'WebflowIcon'
